import { AxiosError } from 'axios';
import { isEmpty as _isEmpty } from 'lodash-es';
import { message, notification } from 'antd';
import { Translation } from 'react-i18next';

const errorCodes = {
  400: {
    meaning: 'BAD REQUEST',
    message: 'Invalid syntax for this request was provided.'
  },
  401: {
    meaning: 'UNAUTHORIZED',
    message: 'You are unauthorized to access the requested resource. Please log in.'
  },
  403: {
    meaning: 'FORBIDDEN',
    message: 'Your account is not authorized to access the requested resource.'
  },
  404: {
    meaning: 'NOT FOUND',
    message: 'We could not find the resource you requested.'
  },
  405: {
    meaning: 'METHOD NOT ALLOWED',
    message: 'This method type is not currently supported.'
  },
  408: {
    meaning: 'REQUEST TIMEOUT',
    message: 'API Request timeout.'
  },
  500: {
    meaning: 'INTERNAL SERVER ERROR',
    message: 'Oops! We are so sorry for this. Please try again after some time.'
  }
};

const defaultErrorMessage = 'Something went wrong. Please try again after some time.';

// --- Class to throw user errors
export class UserError extends Error {
  constructor(errorObject) {
    super(errorObject);

    // --- Extract required data from error object
    const { error, customMessage } = errorObject;
    const { response={} } = error;

    // --- Get Error status from error object
    this.getErrorStatus(response, customMessage);
    
  }

  // --- Function to Get Error status from error object
  getErrorStatus(response, customMessage) {
    let getErrorMessage = '';
    const responseCode = this.isStatusCodeExists(response);

    if (_isEmpty(customMessage)) {
      getErrorMessage = responseCode?.message;
    } else {
      getErrorMessage = customMessage;
    }
    this.showMessageToaster(getErrorMessage || defaultErrorMessage);
  }

  // --- Show message toaster
  showMessageToaster(errorMessage) {
    if (_isEmpty(errorMessage)) return null;

    message.error(errorMessage);
  }

  isStatusCodeExists(response) {
    if (_isEmpty(response)) return null;

    let errorCodeObject = {};
    const { status } = response;

    if (errorCodes.hasOwnProperty(status)) {
      errorCodeObject = errorCodes[status];
    } else {
      // -- Return received error status and its message
      errorCodeObject = {
        meaning: response?.status,
        message: response?.statusText || response?.message
      };
    }

    return errorCodeObject;
  }
}

// -- Class to throw Application errors
export class ApplicationError extends Error {
  constructor(errorObject) {
    super(errorObject);

    // --- Extract required data from error object
    const { error, customMessage } = errorObject;
    // console.log('error-----', error instanceof AxiosError);

    // Dev error
    if (error instanceof AxiosError) {
    }

    this.showMessageStickyNotes(error, customMessage);
  }

  // --- Show system message sticky toaster
  showMessageStickyNotes(error, customMessage) {
    if (_isEmpty(customMessage)) return null;

    this.openNotificationWithIcon('error', customMessage);
  }

  openNotificationWithIcon(type, customMessage) {
    notification[type]({
      // eslint-disable-next-line react/react-in-jsx-scope
      message: <Translation>{t=>{t(customMessage)}}</Translation>  || 'Something went wrong',
      description: customMessage,
      duration: 0
    });
  }
}

// --- Function to show developer errors
export const throwDevError = message => {
  if (process.env.NODE_ENV === 'development') {
    if (!_isEmpty(message)) {
      message.error(message);
    } else {
      message.error(defaultErrorMessage);
    }
  }
};
